import { render, staticRenderFns } from "./BranchSetupView.vue?vue&type=template&id=30733d0c"
import script from "./BranchSetupView.vue?vue&type=script&lang=js"
export * from "./BranchSetupView.vue?vue&type=script&lang=js"
import style0 from "./BranchSetupView.vue?vue&type=style&index=0&id=30733d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports